import { configureStore, ThunkAction, Action } from "@reduxjs/toolkit";
import logger from "redux-logger";
import rootReducer from "./reducers";
import { persistStore, persistReducer, createTransform } from "redux-persist";
import storage from "redux-persist/lib/storage";

const hospitalTransform = createTransform(
  (inboundState: any) => {
    return {
      selectedHospital: inboundState.selectedHospital,
      hospitalToSchemeCodesMap: inboundState.hospitalToSchemeCodesMap,
    };
  },
  (outboundState: any) => {
    return outboundState;
  }
);

const persistConfig = {
  key: "root",
  storage,
  transforms: [hospitalTransform],
  whitelist: ["hospital"],
};

// Create persisted reducer
const persistedReducer = persistReducer(persistConfig, rootReducer);

export const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    // getDefaultMiddleware({
    //   serializableCheck: false,
    // }),
  getDefaultMiddleware({
    serializableCheck: false,
  }).concat(logger),
  devTools: process.env.NODE_ENV !== "production",
});

export const persistor = persistStore(store);

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
export type AppThunk<ReturnType = void> = ThunkAction<
  ReturnType,
  RootState,
  unknown,
  Action<string>
>;
